module.exports = __webpack_public_path__ + "img/1ce8a9c.png";